$(document).ready(function() {
    var SERVER_URL = 'https://padelpartner.no/ppplus';
    var check_page = __st['pageurl'];
    if (check_page == 'www.pppluss.no/pages/registrering') {
        //alert('This is the Home Page!');
        // Ensure the DOM is fully loaded before running the script
        setTimeout(function() {
            // Select the form within the parent class 'globo-formbuilder'
            var $form = $('.globo-formbuilder form');

            if ($form.length > 0) {
                // Store the original form action in localStorage
                var originalAction = $form.attr('action');
                localStorage.setItem('originalFormAction', originalAction);

                // Set the form action to blank
                $form.attr('action', '');

                // Add class 'dev_test' to the submit button
                var $submitButton = $form.find('button[type="submit"]');
                $submitButton.addClass('dev_globo_form_verify');

                // Add click event listener to the document for 'dev_test' button
                $(document).on('click', '.dev_globo_form_verify', function(event) {
                    // Prevent default form submission
                    event.preventDefault();

                    // Remove error message
                    $form.find('.messages').html('');

                    // Check if .messages .error exists and is blank
                    var errorMessage = $form.find('.messages .error').text().trim();
                    if (errorMessage === '') {
                        // Prepare form data
                        var fd = new FormData();
                        fd.append('method_call', 'globo_form_verify');

                        // Append other form data
                        var other_data = $form.serializeArray();
                        $.each(other_data, function(key, input) {
                            fd.append(input.name, input.value);
                        });

                        // Call API
                        $.ajax({
                            url: SERVER_URL +'/data_request.php',
                            //url: SERVER_URL + '/data_request.php',
                            method: 'POST',
                            data: fd,
                            processData: false,
                            contentType: false,
                            success: function(response) {
                                // Handle successful response
                                //alert('API call successful!');
                                console.log(response);
                                var res = JSON.parse(response);
                                
                                if (res.success == true) {
                                    $('.dev_globo_form_verify').removeClass('dev_globo_form_verify').addClass('dev_otp_verify');
                                    var htmlToAppend = '<div id="otp_form_control" class="globo-form-control layout-1-column">' +
                                        '<label for="0-text-4" class="classic-label globo-label">' +
                                        '<span class="label-content" data-label="Sted">Her taster du bekreftelseskode sendt deg pÃ¥ e-post</span><span></span></label>' +
                                        '<div class="globo-form-input">' +
                                        '<input type="text" data-type="text" class="classic-input hidden" id="0-insert_id" name="insert_id" placeholder="" value="'+ res.inserted_id +'">' +
                                        '<input type="text" data-type="text" class="classic-input" id="0-otp" name="otp" placeholder="">' +
                                        '</div>' +
                                        '<small class="help-text globo-description"></small>' +
                                        '<small class="dev_otp_text">Vennligst sjekk din e-post og tast inn kode</small>' +
                                        '<small class="messages dev_otp_error"></small>' +
                                        '</div>';

                                    $('.panel.movingIn.block-container').append(htmlToAppend);
                                }else if (res.success == false) {
                                    $('.dev_globo_form_verify').removeClass('dev_globo_form_verify');
                                    var storedAction = localStorage.getItem('originalFormAction');
                                    //$form.attr('action', storedAction);
                                    if (storedAction) {
                                        $form.attr('action', storedAction);
                                        //localStorage.removeItem('originalFormAction');  // Remove item from localStorage
                                    }
                                    $submitButton.trigger('click');
                                    $form.attr('action', '');
                                    $submitButton.addClass('dev_globo_form_verify');
                                }
                            },
                            error: function(xhr, status, error) {
                                // Handle error response
                                alert('API call failed!');
                                console.error(xhr.responseText);
                            }
                        });
                    } else {
                        // Error message is not blank
                        alert("Error message is not blank");
                    }
                });

                // Add click event listener to the document for 'dev_otp_verify' button
                $(document).on('click', '.dev_otp_verify', function(event) {
                    // Prevent default form submission
                    event.preventDefault();

                    // Remove error message
                    $form.find('.messages').html('');

                    // Check if .messages .error exists and is blank
                    var errorMessage = $form.find('.messages .error').text().trim();
                    if (errorMessage === '') {
                        // Prepare form data
                        var fd = new FormData();
                        fd.append('method_call', 'otp_verify');

                        // Append other form data
                        var other_data = $form.serializeArray();
                        $.each(other_data, function(key, input) {
                            fd.append(input.name, input.value);
                        });

                        // Call API
                        $.ajax({
                            url: SERVER_URL + '/data_request.php',
                            method: 'POST',
                            data: fd,
                            processData: false,
                            contentType: false,
                            success: function(response) {
                                // Handle successful response
                                //alert('API otp call successful!');
                                console.log(response);
                                var res = JSON.parse(response);
                                if ((res.success == true)) {
                                    $('#otp_form_control').remove();
                                    $('.dev_otp_verify').removeClass('dev_otp_verify');
                                    // Additional handling for success
                                    var storedAction = localStorage.getItem('originalFormAction');
                                    //$form.attr('action', storedAction);
                                    if (storedAction) {
                                        $form.attr('action', storedAction);
                                        localStorage.removeItem('originalFormAction');  // Remove item from localStorage
                                    }
                                    $submitButton.trigger('click');
                                }else if (res.success == false) {
                                    var htmlToAppend_err = '<p class="help-block error">Feil kode</p>';
                                    $('.dev_otp_error').append(htmlToAppend_err);
                                }
                            },
                            error: function(xhr, status, error) {
                                // Handle error response
                                alert('API call failed!');
                                console.error(xhr.responseText);
                            }
                        });
                    } else {
                        // Error message is not blank
                        alert("Error message is not blank");
                    }
                });
            }
        }, 1000); // Adjust the timeout duration as needed
    }
});